module.exports = __webpack_public_path__ + "img/22.1a26d6c3.jpeg";